import { AxiosResponse } from 'axios'
import queryString from 'query-string'
import axios from './requestInterceptor'
import {
  getCurrentInvoicesTypes,
  getFinancialReportParams,
  getInvoicesTypes,
  IDepositData,
  IErrorCallback,
  IResponse,
  IRetrieveTransactionsHistogramData,
  ISuccessCallback,
  ITransactionData,
  IWithdrawData,
  PaginatedResponse,
  retrieveInvoiceUrlParam
} from './types'

export async function depositRequest(
  userId: string,
  data: IDepositData,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .post(`/users/${userId}/transactions/deposit/`, data)
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function withdrawRequest(
  userId: string,
  data: IWithdrawData,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .post(`/users/${userId}/transactions/withdraw/`, data)
    .then((response) => {
      successCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export interface ListTransactionsMeta {
  total_deposit?: number
  total_withdraw?: number
  wallet?: number
}

export interface GetTransactionResponse {
  unique_id: string
  trace_number: null | string
  amount: number
  vat: number
  wallet: number
  method: string
  status: string
  paid_at: string | null
  description: null | string
  rejection_description: null | string
  user_data: UserData
  created_at: string
  masked_card_number: null | string
}

export async function ListTransactionRequest(
  userId: string | undefined,
  data: ITransactionData,
  successCallback: ISuccessCallback<AxiosResponse<PaginatedResponse<GetTransactionResponse, ListTransactionsMeta>>>,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/transactions`, {
      params: data,
      paramsSerializer: function (params) {
        return queryString.stringify(params)
      }
    })
    .then((response) => {
      successCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export interface GetInvoiceRequest {
  unique_id: string
  start_datetime: string
  end_datetime: string
  description: string
  number: number
  video_programs_costs: number
  banner_programs_costs: number
  native_programs_costs: number
  rental_programs_costs: number
  user_data: UserData
  created_at: string
}

export interface ListInvoicesMeta {
  total_banner_programs_costs?: number
  total_native_programs_costs?: number
  total_video_programs_costs?: number
  total_rental_programs_costs?: number
}

export async function getInvoiceListRequest(
  userId: string | undefined,
  data: getInvoicesTypes,
  successCallback: ISuccessCallback<PaginatedResponse<GetInvoiceRequest, ListInvoicesMeta>>,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/invoices`, {
      params: data
    })
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export interface GetCurrentInvoiceResponse {
  banner_cost: number
  native_cost: number
  video_cost: number
}

export async function getCurrentInvoiceRequest(
  userId: string | undefined,
  data: getCurrentInvoicesTypes,
  successCallback: ISuccessCallback<GetCurrentInvoiceResponse[]>,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/reports/invoice/`, {
      params: data
    })
    .then((response) => {
      successCallback(response.data.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export interface GetInvoiceDetailsResponse {
  unique_id: string
  start_datetime: Date
  end_datetime: Date
  description: string
  number: number
  video_programs_costs: number
  banner_programs_costs: number
  native_programs_costs: number
  rental_programs_costs: number
  user_data: UserData
  created_at: Date
}

export interface UserData {
  city: null | string
  iban: null | string
  email: string
  gender: null | string
  address: null | string
  company: string | null
  country: null | string
  province: null | string
  username: null | string
  bank_name: null | string
  last_name: string
  telephone: null | string
  birth_date: null | string
  first_name: string
  card_number: null | string
  national_id: null | string
  person_type: PersonTypes
  postal_code: null | string
  phone_number: string
  business_type: string
  economic_code: null | string
  bank_account_number: null | string
  company_registration_number: null | string
}

export enum PersonTypes {
  Real = 0,
  Legal = 1,
  Unknown = 2
}

export async function retrieveInvoiceRequest(
  params: retrieveInvoiceUrlParam,
  successCallback: ISuccessCallback<GetInvoiceDetailsResponse>,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${params.userId}/invoices/${params.invoiceId}`)
    .then((response) => {
      successCallback(response.data.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export interface GetTransactionsHistogramResponse {
  native_cost: number
  video_cost: number
  banner_cost: number
  increase_wallet: number
  bucket: Bucket
}

export interface Bucket {
  year: number
  month: number
  day: number
  week_of_year: number
  day_of_year: number
  day_of_week: number
}

export async function retrieveTransactionsHistogramRequest(
  userId: string | undefined,
  data: IRetrieveTransactionsHistogramData,
  successCallback: ISuccessCallback<IResponse<GetTransactionsHistogramResponse[]>>,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/reports/budget-histogram/`, {
      params: data,
      paramsSerializer: function (params) {
        return queryString.stringify(params)
      }
    })
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function getFinancialReportRequest(
  userId: string | undefined,
  data: getFinancialReportParams,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/financial_report`, {
      params: data,
      paramsSerializer: function (params) {
        return queryString.stringify(params)
      }
    })
    .then((response) => {
      successCallback(response.data.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}
